import { atom } from "jotai";

export const hashedEmailAtom = atom<string | null>(null);
